import { makeObservable } from 'mobx';
import { Common } from 'src/AppState/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { BonusBalanceProgressModel } from './BonusBalanceProgressModel';

export class BonusBalanceProgressStore {
    public static get = AutoWeakMap.create(
        (common: Common, accountId: number, bonusId: string) =>
            new BonusBalanceProgressStore(common, accountId, bonusId)
    );

    private readonly bonusBalanceProgressResource: Resource<BonusBalanceProgressModel | 'error'>;

    public constructor(
        private readonly common: Common,
        private readonly accountId: number,
        private readonly bonusId: string
    ) {
        makeObservable(this);

        this.bonusBalanceProgressResource = new Resource(async (): Promise<BonusBalanceProgressModel | 'error'> => {
            try {
                const response =
                    await this.common.trpcClient.client.bonusCampaignsRouter.getBonusBalanceProgress.mutate({
                        accountId: this.accountId,
                        bonusId: this.bonusId,
                    });

                if (response.status === 200) {
                    return new BonusBalanceProgressModel(response.body);
                }

                console.error(`Unexpected http response`, response);
            } catch (error) {
                console.error('Error fetching campaign:', error);
            }

            return 'error';
        });
    }

    public get bonusBalanceProgressModel(): BonusBalanceProgressModel | 'loading' | 'error' {
        const data = this.bonusBalanceProgressResource.get();

        if (data.type === 'loading') {
            return 'loading';
        }

        if (data.type === 'ready') {
            return data.value;
        }

        return 'error';
    }
}
